import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import type { CampaignSearch } from './search';
import { utcDateStr } from '../lib/dateUtils';
import {
  DEFAULT_TIME_PERIOD,
  sentimentRangeFor,
  type SentimentRange,
  type TimePeriod,
} from '../campaign-reporting/reportingWindow';

export function useSentimentRange(): {
  preset: TimePeriod;
  range: SentimentRange;
  setPreset: (p: TimePeriod) => void;
} {
  const { win } = useSearch({ strict: false }) as Partial<CampaignSearch>;
  const navigate = useNavigate();

  const preset = win ?? DEFAULT_TIME_PERIOD;
  const range: SentimentRange = sentimentRangeFor(preset, utcDateStr());

  const setPreset = useCallback(
    (p: TimePeriod) =>
      navigate({
        to: '.',
        search: (prev: Partial<CampaignSearch>) => ({ ...prev, win: p }),
      } as never),
    [navigate],
  );

  return { preset, range, setPreset };
}
